export default (profileTypeId) => `/api/profiletypes/${profileTypeId}/logo`;
